export interface ExternalAccessTokenQueryRead {
	accessToken: string;
	roleId: string;
	identityId: string;
}

function firstNonEmpty(...vals: (string | null | undefined)[]): string {
	for (const v of vals) {
		if (v == null) continue;
		const t = v.trim();
		if (t !== "") return t;
	}
	return "";
}

function readFromParams(params: URLSearchParams): ExternalAccessTokenQueryRead {
	return {
		accessToken: firstNonEmpty(params.get("accessToken"), params.get("access_token")),
		roleId: firstNonEmpty(params.get("roleId"), params.get("role_id")),
		identityId: firstNonEmpty(params.get("identityId"), params.get("identity_id")),
	};
}

export function readExternalAccessTokenQueryFromLocation(loc: Pick<Location, "search" | "hash">): ExternalAccessTokenQueryRead {
	let { accessToken, roleId, identityId } = readFromParams(new URLSearchParams(loc.search));

	if (!accessToken || !roleId) {
		const hash = loc.hash ?? "";
		const q = hash.indexOf("?");
		if (q >= 0) {
			const fromHash = readFromParams(new URLSearchParams(hash.slice(q + 1)));
			if (!accessToken) accessToken = fromHash.accessToken;
			if (!roleId) roleId = fromHash.roleId;
			if (!identityId) identityId = fromHash.identityId;
		}
	}

	return { accessToken, roleId, identityId };
}

const ACCESS_QUERY_DELETE_KEYS = ["accessToken", "access_token", "roleId", "role_id", "identityId", "identity_id"];

export function stripExternalAccessTokenParamsFromBrowserUrl(): void {
	if (typeof window === "undefined") return;

	const url = new URL(window.location.href);
	let changed = false;

	for (const k of ACCESS_QUERY_DELETE_KEYS) {
		if (url.searchParams.has(k)) {
			url.searchParams.delete(k);
			changed = true;
		}
	}

	const rawHash = url.hash;
	const q = rawHash.indexOf("?");
	if (q >= 0) {
		const hashBase = rawHash.slice(0, q);
		const hp = new URLSearchParams(rawHash.slice(q + 1));
		for (const k of ACCESS_QUERY_DELETE_KEYS) {
			if (hp.has(k)) {
				hp.delete(k);
				changed = true;
			}
		}
		const tail = hp.toString();
		url.hash = tail ? `${hashBase}?${tail}` : hashBase;
	}

	if (changed) {
		window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
	}
}
